'use client'
import React from 'react'
import PrivacyPolicySection from './components/PrivacyPolicySection'
import TermsConditionSection from './components/TermsConditionSection'

function PrivacyPolicyPage() {
   return (
      <>
         <PrivacyPolicySection />
         <TermsConditionSection />
      </>
   )
}

export default PrivacyPolicyPage
